var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33594 8.5013C1.33594 5.98714 1.33594 4.73007 2.11699 3.94902C2.89803 3.16797 4.15511 3.16797 6.66927 3.16797H9.33594C11.8501 3.16797 13.1072 3.16797 13.8882 3.94902C14.6693 4.73007 14.6693 5.98714 14.6693 8.5013V9.83464C14.6693 12.3488 14.6693 13.6059 13.8882 14.3869C13.1072 15.168 11.8501 15.168 9.33594 15.168H6.66927C4.15511 15.168 2.89803 15.168 2.11699 14.3869C1.33594 13.6059 1.33594 12.3488 1.33594 9.83464V8.5013Z",
    stroke: "#a4a4a4",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66406 3.16797V2.16797",
    stroke: "#a4a4a4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3359 3.16797V2.16797",
    stroke: "#a4a4a4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66406 6.5H14.3307",
    stroke: "#a4a4a4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9974 11.8333C11.9974 12.2015 11.6989 12.5 11.3307 12.5C10.9625 12.5 10.6641 12.2015 10.6641 11.8333C10.6641 11.4651 10.9625 11.1667 11.3307 11.1667C11.6989 11.1667 11.9974 11.4651 11.9974 11.8333Z",
    fill: "#a4a4a4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9974 9.16667C11.9974 9.53486 11.6989 9.83333 11.3307 9.83333C10.9625 9.83333 10.6641 9.53486 10.6641 9.16667C10.6641 8.79848 10.9625 8.5 11.3307 8.5C11.6989 8.5 11.9974 8.79848 11.9974 9.16667Z",
    fill: "#a4a4a4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66927 11.8333C8.66927 12.2015 8.37079 12.5 8.0026 12.5C7.63441 12.5 7.33594 12.2015 7.33594 11.8333C7.33594 11.4651 7.63441 11.1667 8.0026 11.1667C8.37079 11.1667 8.66927 11.4651 8.66927 11.8333Z",
    fill: "#a4a4a4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66927 9.16667C8.66927 9.53486 8.37079 9.83333 8.0026 9.83333C7.63441 9.83333 7.33594 9.53486 7.33594 9.16667C7.33594 8.79848 7.63441 8.5 8.0026 8.5C8.37079 8.5 8.66927 8.79848 8.66927 9.16667Z",
    fill: "#a4a4a4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 11.8333C5.33333 12.2015 5.03486 12.5 4.66667 12.5C4.29848 12.5 4 12.2015 4 11.8333C4 11.4651 4.29848 11.1667 4.66667 11.1667C5.03486 11.1667 5.33333 11.4651 5.33333 11.8333Z",
    fill: "#a4a4a4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 9.16667C5.33333 9.53486 5.03486 9.83333 4.66667 9.83333C4.29848 9.83333 4 9.53486 4 9.16667C4 8.79848 4.29848 8.5 4.66667 8.5C5.03486 8.5 5.33333 8.79848 5.33333 9.16667Z",
    fill: "#a4a4a4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.78355709c1df05258b10493a0858f16c.svg";
export { ForwardRef as ReactComponent };